import { createReducer, on } from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import {
  statsGroupLoad,
  statsGroupLoadSuccess,
  statsGroupLoadFail,
} from "../../actions/admin/stats-group.actions";
import { StatElement } from "src/app/shared/interfaces/student";
import { RequestStatus } from "src/app/shared/interfaces/request-status";

export interface StatsGroupState {
  stats: StatElement | null;
  status: RequestStatus;
  error: HttpErrorResponse | null;
}

const initialState: StatsGroupState = {
  stats: null,
  status: "IDLE",
  error: null,
};

export const statsGroupReducer = createReducer(
  initialState,
  on(
    statsGroupLoad,
    (state): StatsGroupState => ({
      ...state,
      stats: null,
      status: "PENDING",
    }),
  ),
  on(
    statsGroupLoadSuccess,
    (state, action): StatsGroupState => ({
      ...state,
      stats: action.stats,
      status: "SUCCESS",
      error: null,
    }),
  ),
  on(
    statsGroupLoadFail,
    (state, { error }): StatsGroupState => ({
      ...state,
      status: "FAILED",
      error,
    }),
  ),
);
